import React from "react";
import AuthCallbackComponent from "../../components/AuthCallback";

const AuthCallback = () => {
  return <AuthCallbackComponent />;
};

export default AuthCallback;